export default {
  MODULE: "module",
  ANTHOLOGY: "anthology",
  COLLECTION: "collection",
  CONTENT: "content",
  CHAPTER: "chapter",
};
